const WA_LINK = "https://wa.me/971585994891?text=Hi%2C%20I%20need%20help%20with%20SellStuff";

export default function WhatsAppButton() {
  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with SellStuff support on WhatsApp"
      data-testid="whatsapp-support-btn"
      className="fixed flex h-12 w-12 items-center justify-center rounded-full text-white shadow-lg transition-transform hover:scale-105 sm:h-14 sm:w-14"
      style={{ bottom: "24px", right: "24px", backgroundColor: "#25D366", zIndex: 9999 }}
    >
      <i className="ti ti-brand-whatsapp" style={{ fontSize: "28px" }} />
    </a>
  );
}
